import ActionBtn from "components/buttons/ActionBtn";
import { RefreshButton } from "components/buttons/RefreshButton";
import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import { t } from "i18next";
import React from "react";

type Props = {
  options?: { label: string; value: string }[];
  hasCreateButton?: boolean;
  createModal?: () => void;
  selectAction?: (v: string) => void;
  isDisabledOptions?: boolean;
  refresh?: () => void;
  isRefreshRequested?: boolean;
};

export const ZonesHeader: React.FC<Props> = ({
  options,
  hasCreateButton = false,
  createModal = () => {},
  selectAction = () => {},
  isDisabledOptions = true,
  refresh =  () => {},
  isRefreshRequested,
}) => {
  return (
    <div className="page-list-header">
      {hasCreateButton && (
        <div className="page-list-header--box">
          <ActionBtn
            txt={t("createZone")}
            handleClick={() => {
              if (createModal) {
                createModal();
              }
            }}
          />
        </div>
      )}
      <div className="page-list-header--box page-list-header--box--right">
        <RefreshButton
          position="right"
          disabled={isRefreshRequested}
          isLoading={isRefreshRequested}
          onClick={() => refresh()}
        />
      </div>

      {/* <div className="page-list-header--box">
        <ActionBtn
          txt={t("addNotification")}
          handleClick={() => {
            if (createModal) {
              createModal();
            }
          }}
        />
      </div> */}
      {options && (
        <div className="page-list-header--box">
          <DefaultDropdown
            onSelect={(e) => {
              if (selectAction) {
                selectAction(e as string);
              }
            }}
            placeholder={t("chooseAction")}
            options={options}
            isSmall
            disabled={isDisabledOptions}
          />
        </div>
      )}
    </div>
  );
};
